<script>
  import ActionButton from '~/components/ActionButton.svelte';
  import AwardIcon from '~/icons/AwardIcon.svelte';
  import { leaderboardModal } from './LeaderboardModal.svelte';

  const handleOpenLeaderboard = () => {
    leaderboardModal.push();
  };
</script>

<ActionButton
  class="award-icon"
  buttonId="leaderboard-button"
  onClick={handleOpenLeaderboard}
>
  <AwardIcon size="1.5em" />
  View leaderboard
</ActionButton>

<style>
  :global(#leaderboard-button > svg) {
    overflow: visible;
    fill: none;
    stroke: currentColor;
    stroke-width: 3px;
  }
</style>
